import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {calculateRemSize, flexAbsoluteCenter} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";

import {IReelSize} from "../../../types/IReelSize";

interface IProps {
    size: IReelSize;
    logoSrc: string;
    autorInfo: string;
    className?: string;
}

export const ReelAuthorLogo = (props: IProps) => {
    return (
        <ReelAuthorLogoWrapper size={props.size} className={props.className}>
            <Image src={props.logoSrc} alt={props.autorInfo} width="100%" height="100%" css={logoStyle} />
        </ReelAuthorLogoWrapper>
    );
};

const ReelAuthorLogoWrapper = styled.div<{size: IReelSize}>`
    ${flexAbsoluteCenter};
    position: relative;
    border: 2px solid ${({theme}) => theme.colors.gray[400]};
    overflow: hidden;

    ${({size}) =>
        size === "S"
            ? css`
                  width: ${calculateRemSize(4)};
                  height: ${calculateRemSize(4)};
                  border-radius: ${calculateRemSize(2)};
              `
            : css`
                  width: ${calculateRemSize(6)};
                  height: ${calculateRemSize(6)};
                  border-radius: ${calculateRemSize(3)};
              `}
`;

const logoStyle = css`
    width: 100%;
    height: 100%;

    img {
        object-fit: cover;
    }
`;
import React from "react";
import {css} from "@emotion/react";
import styled from "@emotion/styled";

import {calculateRemSize, flexAbsoluteCenter} from "@pg-design/helpers-css";
import {Image} from "@pg-design/image-module";

import {IReelSize} from "../../../types/IReelSize";

interface IProps {
    size: IReelSize;
    logoSrc: string;
    autorInfo: string;
    className?: string;
}

export const ReelAuthorLogo = (props: IProps) => {
    return (
        <ReelAuthorLogoWrapper size={props.size} className={props.className}>
            <Image src={props.logoSrc} alt={props.autorInfo} width="100%" height="100%" css={logoStyle} />
        </ReelAuthorLogoWrapper>
    );
};

const ReelAuthorLogoWrapper = styled.div<{size: IReelSize}>`
    ${flexAbsoluteCenter};
    position: relative;
    border: 2px solid ${({theme}) => theme.colors.gray[400]};
    overflow: hidden;

    ${({size}) =>
        size === "S"
            ? css`
                  width: ${calculateRemSize(4)};
                  height: ${calculateRemSize(4)};
                  border-radius: ${calculateRemSize(2)};
              `
            : css`
                  width: ${calculateRemSize(6)};
                  height: ${calculateRemSize(6)};
                  border-radius: ${calculateRemSize(3)};
              `}
`;

const logoStyle = css`
    width: 100%;
    height: 100%;

    img {
        object-fit: cover;
    }
`;
